module.exports = __webpack_public_path__ + "img/kla-klok icon 1.b443c03a.png";